import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {toast} from "react-toastify";
import apiClient from "../../../../utils/apiClient";
import Breadcrumb from "../../../common/breadcrumb";
import FormInputNumber from "../../../forms/form-control/FormInputNumber";
import FormSubmitButton from "../../../forms/form-control/FormSubmitButton";
import LoadingIndicator from "../../../common/loadingIndicator";

const ShiftReportRates = () => {
  const {register, handleSubmit, setValue, errors} = useForm();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    apiClient.get("shiftReportRates").then((response) => {
      setData(response.data);
      setValue('drillerRate', response.data[0].rate);
      setValue('drillerAssistantRate', response.data[1].rate);
      setIsLoading(false);
    });
  }, [setValue]);

  const onSubmit = (formData) => {
      const body = [
        {
          ...data[0],
          rate: formData.drillerRate
        },
        {
          ...data[1],
          rate: formData.drillerAssistantRate
        }
      ]
      setIsLoading(true);
      apiClient
          .post('shiftReportRates', body)
          .then(response => {
            setIsLoading(false);
            toast.success(response.data.message);
          })
  };

  return (
    <>
      <Breadcrumb title="Shift Report Rates" parent="Admin" />
      <div className="container-fluid">
          <form
              className="needs-validation container-fluid"
              onSubmit={handleSubmit(onSubmit)}
          >
            <div className="form-row">
              <FormInputNumber
                id="drillerRate"
                label="Driller Hourly Rate"
                className="col-md-3"
                type="text"
                errors={errors}
                register={register({required: "required", min: {
                  value: 0,
                  message: "Value must be at least 0"
              }})}
              />
              <FormInputNumber
                id="drillerAssistantRate"
                label="Driller Assistant Hourly Rate"
                className="col-md-3"
                type="text"
                errors={errors}
                register={register({required: "required", min: {
                  value: 0,
                  message: "Value must be at least 0"
              }})}
              />
            </div>
            <div className="form-row">
              <FormSubmitButton className="col-md-2" label="Save" />
            </div> 
          </form>
          <LoadingIndicator isLoading={isLoading} />
      </div>
    </>
  );
};

export default ShiftReportRates;
